import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSignUp = async () => {
    if (password !== confirmPassword) {
      alert("Password and Confirm Password do not match");
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/signup`, {
        name,
        email,
        password
      });

      alert("Signup Successful!");
      navigate("/login");    // Redirect to Login
    } 
    catch (error) {
      alert(error.response?.data?.message || "Signup failed");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-md">
        <h2 className="text-3xl font-bold text-center mb-6">Create Account</h2>

        {/* Name */}
        <label className="block text-gray-600 font-medium">Name</label>
        <input onChange={(e) => setName(e.target.value)} type="text" placeholder="Enter your name" className="w-full p-3 border rounded-lg mt-1 mb-4 focus:outline-none focus:border-blue-500"/>

        {/* Email */}
        <label className="block text-gray-600 font-medium">Email</label>
        <input onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Enter your email" className="w-full p-3 border rounded-lg mt-1 mb-4 focus:outline-none focus:border-blue-500"/>

        {/* Password */}
        <label className="block text-gray-600 font-medium">Password</label>
        <input onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Enter your password" className="w-full p-3 border rounded-lg mt-1 mb-4 focus:outline-none focus:border-blue-500"/>

        {/* Confirm Password */}
        <label className="block text-gray-600 font-medium">Confirm Password</label>
        <input onChange={(e) => setConfirmPassword(e.target.value)} type="password" placeholder="Confirm your password" className="w-full p-3 border rounded-lg mt-1 mb-6 focus:outline-none focus:border-blue-500"/>

        {/* Sign Up Button */}
        <button onClick={handleSignUp} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg transition"> Sign Up </button>

        {/* Login Link */}
        <p className="text-center text-sm text-gray-500 mt-4">
          Already have an account?{" "}
          <span className="text-blue-600 cursor-pointer hover:underline" onClick={() => navigate("/login")} > Login </span>
        </p>

      </div>

    </div>
  );
};

export default SignUp;
